// @flow
import React, { Component } from 'react';
import { View, StyleSheet, Image, Dimensions, Platform } from 'react-native';
import RNFS from 'react-native-fs';

import CameraWrapper from '../../../utils/cameraWrapper';

import { FullButton } from '../../../components/common';
import I18n from '../../../lib/i18n';
import Toast from '../../../lib/toastService';
import theme from '../../../theme-config';

import type { NavigationRoute, NavigationScreenProp } from '@react-navigation/compat';
import WizzeeLog from '../../../lib/wizzeeLog';

type Props = {
  cameraActivated: boolean,
  navigation: NavigationScreenProp<NavigationRoute>,
  setSelfieIdentification: Function,
};

class SelfieCheck extends Component<Props> {
  // Update reference type for Vision Camera
  camera: any;

  handleCapture = (result: string) => {
    this.props.setSelfieIdentification({
      contentBase64: result,
      contentMediaType: 'image/jpg',
    });
    this.props.navigation.navigate('confirmPlanDuringActivate');
  };

  takePicture = async () => {
    if (!this.camera) return;

    try {
      // 1. Take the photo using Vision Camera API
      const photo = await this.camera.takePhoto({
        flash: 'off',
        enableShutterSound: true,
      });

      // 2. Read the file from the temporary path provided by the camera
      // We read it as base64 to match your existing handleCapture logic
      const base64Data = await RNFS.readFile(photo.path, 'base64');

      if (!base64Data) {
        WizzeeLog.warn('[SelfieCheck] missing base64 data');
        return;
      }

      // 3. Clean up formatting and pass to handler
      return this.handleCapture(base64Data.replace(/\n/g, ''));

    } catch (e) {
      WizzeeLog.warn('[SelfieCheck] Error taking picture', e);
      Toast.showError(I18n.t('SignUp.SelfieCheck.error'));
    }
  };

  render() {
    return (
      <View style={styles.container}>
        {this.props.cameraActivated && (
          <CameraWrapper
            ref={ref => {
              this.camera = ref;
            }}
            isActive={true}
            deviceType="back"
            photo={true}
          />
        )}
        <View style={styles.selfieContainer}>
          <Image source={theme.selfieImage} style={styles.selfieImage} />
        </View>
        <View style={styles.overlaysContainer}>
          <FullButton
            text={I18n.t('SignUp.SelfieCheck.button')}
            onPress={this.takePicture}
            testID={'takePictureButton'}
          />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'black',
  },
  camera: {
    flex: 1,
  },
  overlaysContainer: {
    position: 'absolute',
    bottom: 0,
    width: Dimensions.get('window').width,
    paddingBottom: 70,
    paddingHorizontal: 30,
  },
  selfieImage: {
    resizeMode: 'contain',
    width: Dimensions.get('window').width,
  },
  selfieContainer: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'center',
    zIndex: 1, // Ensure the guide overlay is above the camera
  },
});

export default SelfieCheck;